import React from 'react';

const NewFeatureNote = ({children}) => {
  return (
    <div className="note note-danger">
      <div className="row">
        <div className="col-1 d-flex align-items-center">
          <div>
            <img
              width="100%"
              alt="new_icon"
              src={require('../../assets/icons/new_icon.png')}
            />
          </div>
        </div>
        <div className="col-11 d-flex align-items-center">
          <div>{children}</div>
        </div>
      </div>
    </div>
  );
};

export default NewFeatureNote;
